import { observer } from 'mobx-react-lite'
import { Outlet, useParams } from 'react-router'
import { useEffect, useMemo, useState } from 'react'
import { SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { HubspotWorkflowsApi } from 'entities/HubspotWorkflows/api/hubspotWorkflows'
import { HubspotWorkflowsPath } from 'entities/ExportRouters'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  HubspotWorkflowViewContext,
  HubspotWorkflowViewStore,
} from 'pages/hubspotWorkflows/ui/hubspotWorkflowView'
import { useHubspotWorkflowsPageContext } from 'pages/hubspotWorkflows/context/hubspotWorkflowsPageContext'

export const HubspotWorkflowViewAccessLayout = observer(() => {
  const { id } = useParams()
  const entities = useEntitiesContext()
  const { pageLayoutStore } = useHubspotWorkflowsPageContext()
  const [loading, setLoading] = useState(true)

  const store = useMemo(
    () => new HubspotWorkflowViewStore(pageLayoutStore, entities, id),
    [pageLayoutStore, id]
  )

  useEffect(() => {
    if (id) {
      HubspotWorkflowsApi.getHubspotWorkflowById(id)
        .then(({ data }) => {
          if (data) {
            store.setWorkflow(data)
            setLoading(false)
          }
        })
        .catch((e) => {
          logger.error(e)
          setLoading(false)

          uiStore.changeRouteViaVue({
            path: `/${HubspotWorkflowsPath.root}`,
          })
        })
    }
  }, [id])

  if (loading) {
    return <SpinnerLoader ariaLabel={'HubspotWorkflowViewAccessLayout'} />
  }

  return (
    <HubspotWorkflowViewContext.Provider value={store}>
      <Outlet />
    </HubspotWorkflowViewContext.Provider>
  )
})
